<template>
  <div class="TenantLogo" :style="{ width: `${image.width}px` }">
    <img
      :src="src"
      :width="image.width"
      alt=""
      :style="style"
    >
  </div>
</template>

<script>
import { image } from '@/config'

export default {
  data() {
    return {
      image: image,
    }
  },
  computed: {
    src() {
      return require(`../assets/image/${this.image.file}`)
    },
    style() {
      return this.image.color && { background: image.color }
    },
  },
}
</script>

<style lang="scss">

.TenantLogo {
  position: relative;
  margin: 0 16px 0 0;

  img {
    position: absolute;
    left: 0;
    bottom: 0;

    background: white;
    padding: 0.5rem;
    box-shadow: 2px 5px 19px 0px rgba(0,0,0,0.27);
    border-radius: 4px;
  }
}
</style>
